var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.852,
    height: 9.873,
    viewBox: "0 0 7.852 9.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_254_",
    d: "M0,3.751,3.926,0,7.852,3.751Zm0,2.37L3.926,9.873,7.852,6.121Z",
    transform: "translate(0 0)",
    fill: "#5b5b5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.599520fcb7ab2320e0682860b9ec71db.svg";
export { ForwardRef as ReactComponent };